import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import DashHeading from "./DashHeading";
import React from "react";
import RichTextLarge from "./RichTextLarge";
import TakebackStep from "./TakebackStep";
import Text from "./Text";
import TwoColBox from "./TwoColBox";
import { useViewportContext } from "./ViewportContext";

function HowItWorks({ heading, callout, text, steps }) {
  const { innerWidth } = useViewportContext();
  const numberOfRows =
    steps.length % 2 === 0 ? steps.length / 2 : (steps.length - 1) / 2 + 1;

  return (
    <BoxWithGutter pt={[50, null, 100, null]} pb={[80, null, 150, null]}>
      <DashHeading heading={heading} />
      <Box mt={[40, null, 60, null]} mb={[40, null, 130, null]}>
        <TwoColBox
          col1={
            <Text
              as="h3"
              fontSize={[22, 22, 32, 32]}
              lineHeight={["32px", "32px", "42px", "42px"]}
              dangerouslySetInnerHTML={{ __html: callout }}
            />
          }
          col2={<RichTextLarge>{text}</RichTextLarge>}
        />
      </Box>
      <Box
        display="grid"
        gridAutoFlow={[null, null, "column", null]}
        gridTemplateColumns={["1fr", null, "1fr 1fr", null]}
        gridTemplateRows={["auto", null, `repeat(${numberOfRows}, auto)`, null]}
        gridColumnGap={100}
        gridRowGap={[22, null, 38, null]}
        maxWidth="75vw"
        mx="auto"
      >
        {steps.map((step, index) => {
          const hideArrow =
            index == steps.length - 1 ||
            (index === numberOfRows - 1 && innerWidth > 959);

          return (
            <TakebackStep
              key={index}
              {...step}
              number={index + 1}
              showArrow={!hideArrow}
            />
          );
        })}
      </Box>
    </BoxWithGutter>
  );
}

export default HowItWorks;
